import GenericTabs from "@frameworks/web/components/generic/GenericTabs";
import React, { useLayoutEffect, useMemo, useState } from "react";
import { EOtherReportTabs, EReportsQParamKey, OtherReport, } from "../CommonComponent/constant";
import ContractNotes from "../ContractNotes/ContractNotes";
import DpBillsMain from "../DpBills/DpBillsMain";
import SubscriptionFees from "../SubscriptionFees/SubscriptionFees";
import DpInterestMain from "../DpInterest/DpInterestMain";
import "@frameworks/web/stylesheets/components/Reports/DpBills/DpBills.scss";
import "@frameworks/web/stylesheets/components/Reports/otherReports.scss";
import { getQueryParameterName } from "@frameworks/web/utils/urlHelper";
import { createSearchParams, useNavigate } from "react-router-dom";
import LedgerMain from "@frameworks/web/components/Reports/LedgerReports/LedgerReportsMain";
const OtherReports = () => {
    const navigate = useNavigate();
    const otherReportSubTab = getQueryParameterName(EReportsQParamKey.TAB);
    const reportName = getQueryParameterName(EReportsQParamKey.REPORT_NAME);
    const [activereportTab, setActiveReportTab] = useState();
    const ReportTabs = useMemo(() => [
        {
            title: OtherReport[EOtherReportTabs.DP_BILL],
            eventKey: EOtherReportTabs.DP_BILL,
            tabContent: (React.createElement("div", { className: "dp-bills-main-container" },
                React.createElement("div", { id: "dp-bills-main" },
                    React.createElement(DpBillsMain, null)))),
        },
        {
            title: OtherReport[EOtherReportTabs.CONTRACT_NOTES],
            eventKey: EOtherReportTabs.CONTRACT_NOTES,
            tabContent: React.createElement(ContractNotes, null),
        },
        {
            title: OtherReport[EOtherReportTabs.SUBSCRIPTION_HISTORY],
            eventKey: EOtherReportTabs.SUBSCRIPTION_HISTORY,
            tabContent: React.createElement(SubscriptionFees, null),
        },
        {
            title: OtherReport[EOtherReportTabs.DELAYED_PAYMENT_INTEREST],
            eventKey: EOtherReportTabs.DELAYED_PAYMENT_INTEREST,
            tabContent: React.createElement(DpInterestMain, null),
        },
        {
            title: OtherReport[EOtherReportTabs.LEDGER_REPORT],
            eventKey: EOtherReportTabs.LEDGER_REPORT,
            tabContent: React.createElement(LedgerMain, null),
        },
    ], []);
    useLayoutEffect(() => {
        setActiveReportTab(otherReportSubTab !== null && otherReportSubTab !== void 0 ? otherReportSubTab : EOtherReportTabs.DP_BILL);
    }, [otherReportSubTab]);
    return (React.createElement(React.Fragment, null,
        React.createElement(GenericTabs, { defaultActiveKey: activereportTab, tabsArray: ReportTabs, callBackFunction: (tab) => {
                navigate({
                    pathname: "",
                    search: createSearchParams({
                        reportName: reportName,
                        [EReportsQParamKey.TAB]: tab,
                    }).toString(),
                });
            }, activeKey: activereportTab, externalClassName: "other-report-tabs", TabsClassName: "switch-between-reports" })));
};
export default OtherReports;
